/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
export const CalendarContext = createContext({
    calendarSummaryValues: null,
    refreshCalendarSummary: () => { },
    onSubmitHolidayYearForm: () => { },
    freeDays: [],
    refreshHolidayBookings: () => { },
    onSubmitHolidayBooking: () => { },
});
